import React from 'react';
import * as Icon from 'react-feather';
import { Grid, IconButton, Tooltip } from '@material-ui/core';
import PropTypes from 'prop-types';
import { defaultStyles } from 'utils/Theme';
import { useHistory } from 'react-router-dom';

const GroupTableActions = ({ id, handleDelete }) => {
    const _classes = defaultStyles();
    const history = useHistory()

    return (
        <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            style={{ padding: 10 }}
        >
            <Grid item>
                <Tooltip title="View" placement="top">
                    <IconButton
                        onClick={() =>
                            history.push(`/settings/groups/${id}/view`)
                        }
                    >
                        <Icon.Eye className={_classes.colorPrimary} size={16} />
                    </IconButton>
                </Tooltip>
            </Grid>
            <Grid item>
                <Tooltip title="Edit" placement="top">
                    <IconButton
                        onClick={() =>
                            history.push(`/settings/groups/${id}/edit`)
                        }
                    >
                        <Icon.Edit3 className={_classes.colorInfo} size={16} />
                    </IconButton>
                </Tooltip>
            </Grid>
            <Grid item>
                <Tooltip title="Edit" placement="top">
                    <IconButton onClick={handleDelete}>
                        <Icon.Trash
                            className={_classes.colorDanger}
                            size={16}
                        />
                    </IconButton>
                </Tooltip>
            </Grid>
        </Grid>
    );
};

GroupTableActions.propTypes = {
    id: PropTypes.string.isRequired,
    handleDelete: PropTypes.func.isRequired,
};

export default GroupTableActions;
